module.exports = __webpack_public_path__ + "media/assets/images/icons/countries/au-338f864431afb1d8e90bae04ceedfb00.svg";